var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "zw introduction" }, [
    _c("div", { staticClass: "setup" }, [
      _c(
        "div",
        { staticClass: "content" },
        [
          _c("transition", { attrs: { name: "swipe" } }, [
            _vm.currentTick("profile-setup")
              ? _c(
                  "div",
                  {
                    key: _vm.ticks[_vm.activeTick].name,
                    staticClass: "slider-content",
                    class: _vm.clickedClass
                  },
                  [
                    _c("h1", { staticClass: "ui header" }, [
                      _vm._v(
                        "\n            " +
                          _vm._s(
                            _vm.$t("pages.setup.content.profilesetup.header")
                          ) +
                          "\n            "
                      ),
                      _c("div", { staticClass: "sub header" }, [
                        _vm._v(
                          _vm._s(
                            _vm.$t("pages.setup.content.profilesetup.subtext")
                          )
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c("profile-setup", { ref: "ProfileSetup" })
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.currentTick("social-number-setup")
              ? _c(
                  "div",
                  {
                    key: _vm.ticks[_vm.activeTick].name,
                    staticClass: "slider-content",
                    class: _vm.clickedClass
                  },
                  [
                    _c("h1", { staticClass: "ui header" }, [
                      _vm._v(
                        "\n            " +
                          _vm._s(
                            _vm.$t(
                              "pages.setup.content.socialNumberSetup.header"
                            )
                          ) +
                          "\n            "
                      ),
                      _c("div", { staticClass: "sub header" }, [
                        _vm._v(
                          _vm._s(
                            _vm.$t(
                              "pages.setup.content.socialNumberSetup.subtext"
                            )
                          )
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c("social-number-setup", { ref: "SocialNumberSetup" })
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.currentTick("company-setup")
              ? _c(
                  "div",
                  {
                    key: _vm.ticks[_vm.activeTick].name,
                    staticClass: "slider-content",
                    class: _vm.clickedClass
                  },
                  [
                    _c("h1", { staticClass: "ui header" }, [
                      _vm._v(
                        "\n            " +
                          _vm._s(
                            _vm.$t("pages.setup.content.companysetup.header")
                          ) +
                          "\n            "
                      ),
                      _c("div", { staticClass: "sub header" }, [
                        _vm._v(
                          _vm._s(
                            _vm.$t("pages.setup.content.companysetup.subtext")
                          )
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c("company-setup", { ref: "CompanySetup" })
                  ],
                  1
                )
              : _vm.currentTick("first-service")
              ? _c(
                  "div",
                  {
                    key: _vm.ticks[_vm.activeTick].name,
                    staticClass: "slider-content",
                    class: _vm.clickedClass
                  },
                  [
                    _c("h1", { staticClass: "ui header" }, [
                      _vm._v(
                        "\n            " +
                          _vm._s(
                            _vm.$t("pages.setup.content.firstservice.header")
                          ) +
                          "\n            "
                      ),
                      _c("div", { staticClass: "sub header" }, [
                        _vm._v(
                          _vm._s(
                            _vm.$t("pages.setup.content.firstservice.subtext")
                          )
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c("h4", {
                      staticClass: "header",
                      domProps: {
                        innerHTML: _vm._s(
                          _vm.$t("pages.setup.content.firstservice.text")
                        )
                      }
                    }),
                    _vm._v(" "),
                    _vm.isExternalUser
                      ? [
                          _c(
                            "div",
                            { staticClass: "ui basic center aligned segment" },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "ui blue rounded large button",
                                  on: {
                                    click: function($event) {
                                      _vm.showAvailableProductsModal = !_vm.showAvailableProductsModal
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(
                                        _vm.$t(
                                          "pages.setup.content.firstservice.button"
                                        )
                                      ) +
                                      "\n              "
                                  )
                                ]
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c("available-products-modal", {
                            attrs: {
                              active: _vm.showAvailableProductsModal,
                              intro: true
                            }
                          })
                        ]
                      : [
                          _c(
                            "div",
                            { staticClass: "ui basic center aligned segment" },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "ui blue rounded large button",
                                  on: { click: _vm.toggleSubscriptionModal }
                                },
                                [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(
                                        _vm.$t(
                                          "pages.setup.content.firstservice.button"
                                        )
                                      ) +
                                      "\n              "
                                  )
                                ]
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c("new-subscription-modal", {
                            attrs: {
                              active: _vm.showFirstSubscriptionModal,
                              subscription: _vm.firstSubscription,
                              intro: true
                            }
                          })
                        ]
                  ],
                  2
                )
              : _vm._e()
          ])
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "actions" }, [
        _vm.showPrev
          ? _c(
              "div",
              {
                staticClass: "ui large rounded icon labeled button",
                on: {
                  click: function($event) {
                    return _vm.prevTick()
                  }
                }
              },
              [
                _c("i", { staticClass: "angle left icon" }),
                _vm._v(
                  " " + _vm._s(_vm.$t("globals.buttons.previous")) + "\n      "
                )
              ]
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.showNext
          ? _c(
              "div",
              {
                staticClass: "ui blue rounded right labeled large icon button",
                on: {
                  click: function($event) {
                    return _vm.nextTick()
                  }
                }
              },
              [
                _c("i", { staticClass: "angle right icon" }),
                _vm._v(
                  " " + _vm._s(_vm.$t("globals.buttons.next_step")) + "\n      "
                )
              ]
            )
          : !_vm.showNext
          ? _c(
              "div",
              {
                staticClass: "ui blue rounded large icon button",
                class: { disabled: !_vm.finalize },
                on: { click: _vm.finishSetup }
              },
              [
                _vm._v(
                  "\n        " +
                    _vm._s(_vm.$t("globals.buttons.finalize")) +
                    "\n      "
                )
              ]
            )
          : _vm._e()
      ])
    ]),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "menu",
        class: { fullscreen: _vm.ticks[_vm.activeTick].fullscreen }
      },
      [
        _c("div", { staticClass: "content" }, [
          _c("div", { staticClass: "process" }, [
            _c(
              "div",
              { staticClass: "ticks" },
              _vm._l(_vm.ticks, function(tick, tickdex) {
                return _c(
                  "div",
                  {
                    key: tickdex,
                    staticClass: "tick",
                    class: { active: tickdex === _vm.activeTick },
                    on: {
                      click: function($event) {
                        return _vm.switchTick(tickdex)
                      }
                    }
                  },
                  [
                    _vm._v(
                      "\n            " + _vm._s(tickdex + 1) + "\n          "
                    )
                  ]
                )
              }),
              0
            )
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "middle" },
            [
              _c(
                "transition",
                { attrs: { name: "swipe" } },
                _vm._l(_vm.ticks, function(tick, index) {
                  return index === _vm.activeTick
                    ? _c(
                        "div",
                        {
                          key: index,
                          staticClass: "slider-content",
                          class: _vm.clickedClass
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "ui header",
                              class: { icon: !!tick.icon }
                            },
                            [
                              tick.icon
                                ? _c("i", {
                                    staticClass: "icon",
                                    class: tick.icon
                                  })
                                : _vm._e(),
                              _vm._v(
                                " " + _vm._s(tick.header) + "\n            "
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c("div", {
                            staticClass: "description",
                            domProps: { innerHTML: _vm._s(tick.description) }
                          }),
                          _vm._v(" "),
                          tick.button
                            ? _c(
                                "div",
                                {
                                  staticClass:
                                    "ui blue rounded right labeled large icon button",
                                  on: {
                                    click: function($event) {
                                      return _vm.nextTick()
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(tick.button) +
                                      "\n              "
                                  ),
                                  _c("i", { staticClass: "angle right icon" })
                                ]
                              )
                            : _vm._e()
                        ]
                      )
                    : _vm._e()
                }),
                0
              )
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "information" }, [
            _vm.activeMerchant
              ? _c("h4", [_vm._v(_vm._s(this.merchantPhone))])
              : _vm._e(),
            _vm._v(" "),
            _vm.activeMerchant
              ? _c("h4", { staticStyle: { "word-break": "break-all" } }, [
                  _vm._v(_vm._s(this.merchantEmail))
                ])
              : _vm._e()
          ])
        ])
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2187a928", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2187a928","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/setup/UserSetup.vue
// module id = vskw
// module chunks = 1